import Notifications, { notes } from "@phoenixreisen/mithrils/src/notification";
import Loader from "@phoenixreisen/mithrils/src/loader";
import { WEBTEXT_FREE_SITES } from "../shared/constants";
import { logError } from "../../../shared/functions/misc";
import UserTypes from "../shared/usertypes";
import * as Fns from "../shared/functions";
import Context from "../shared/context";
import Config from "../../../config";
import m from "mithril";
const help = require("../images/login-daten.png");
const RouteLink = m.route.Link;
export const View = {
    oninit() {
        Context.browserIsInvalid = Fns.isDinosaurBrowser();
        Context.storageIsNotAvailable = Fns.isLocalStorageDisabled();
    },
    view({ attrs, children }) {
        const { urls } = Config;
        const { userType, key } = attrs;
        const { CUSTOMER, AGENCY } = UserTypes;
        const { webtexte, agencyFormRenderCounter, showHelp } = Context;
        try {
            const linkAnimationClass = agencyFormRenderCounter < 1 ? "tada animated" : "";
            const webtextsAreNeeded = !key || !WEBTEXT_FREE_SITES.includes(key);
            if (!webtexte && webtextsAreNeeded) {
                return m(Loader, { type: "overlay" });
            }
            return (m("section", { class: "login" },
                m("div", { class: "login-box wrapper" },
                    m("header", { class: "login-box-header" },
                        m("div", { class: "header" },
                            m("a", { href: "/cdn/mein-phoenix/login/", target: "_self", class: "header__logo", title: "Zur Mein Phoenix Anmeldung" },
                                m("img", { src: `${process.env.ASSETS}/icons/phoenix-reisen-logo.svg`, role: "presentation" }))),
                        m("h1", null, "Mein Phoenix Anmeldung"),
                        m("div", { class: "c-gray1 text-balance" }, "Hier k\u00F6nnen Sie Ihre bei uns gebuchte Reise verwalten.")),
                    Context.storageIsNotAvailable && (m("aside", { class: "alert alert--danger alert--icon" },
                        m("i", { class: "fas fa-exclamation-triangle" }),
                        m("small", null,
                            "Ohne Cookies geht es leider nicht. Bitte erlauben Sie Ihrem Browser, Cookies von ",
                            m("strong", null, location.host),
                            " setzen zu d\u00FCrfen. Falls Sie dieser Hinweis verunsichert,",
                            " ",
                            m("a", { href: "https://www.phoenixreisen.com/kontakt.html", title: "Zu unserer Kontaktseite", target: "blank" }, "wenden Sie sich gerne direkt an uns.")))),
                    Context.browserIsInvalid && (m("div", { class: "alert alert--warning alert--icon login-box__browser-info" },
                        m("i", { class: "fas fa-exclamation-triangle" }),
                        m("small", null, "Ihr Internet (Browser) scheint nicht in der aktuellsten Version zu sein. Wir k\u00F6nnen deshalb nicht ausschlie\u00DFen, dass Sie unsere Plattform nur eingeschr\u00E4nkt nutzen k\u00F6nnen. Bitte aktualisieren Sie bei Gelegenheit Ihren Browser oder nutzen Sie eine Alternative."))),
                    children,
                    m("div", { class: "login-links" },
                        m("a", { href: urls.IMPRINT, title: "Phoenix Reisen Impressum" }, "Impressum"),
                        m("a", { href: urls.CATALOG, class: "ml3", title: "Verwaltung Ihres Katalog-Abonnements" }, "Kataloge"),
                        m("a", { href: urls.WORKSPACE, class: "ml3", title: "f\u00FCr Phoenix Mitarbeiter" }, "Mitarbeiter"),
                        !!userType && userType !== CUSTOMER && (m(RouteLink, { href: "/kunde", class: `ml3 ${linkAnimationClass}`, title: "Zur Anmeldung als Reisender" }, "Kunden")),
                        !!userType && userType !== AGENCY && (m(RouteLink, { href: "/agentur", class: `ml3 ${linkAnimationClass}`, title: "Zur Anmeldung als Reiseb\u00FCro" }, "Agentur")))),
                showHelp && (m("a", { class: "login-help", href: "javascript:", onclick: () => (Context.showHelp = false), title: "Klicken, um die Hilfe wieder auszublenden" },
                    m("img", { src: help, class: "zoomIn animated faster" }))),
                m(Notifications, { list: notes })));
        }
        catch (e) {
            logError(e);
            location.href = urls.FE_ERROR;
        }
    },
};
export default View;
